import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { Tax } from 'ts/types/Tax'
import { formatter } from 'utils'
import { Boolean as BooleanCell } from 'components/ui'
import CardTable from 'components/CardTable'
import TaxAddPage from './TaxAddPage'

const columns: Column<Tax>[] = [
  {
    Header: 'ID',
    accessor: 'taxTypeId'
  },
  {
    Header: 'Active',
    accessor: 'flActive',
    Cell: ({ value }) => <BooleanCell value={value} />
  },
  {
    Header: 'Tax Name',
    accessor: 'name'
  },
  {
    Header: 'Tax Rate',
    accessor: 'taxRate'
  },
  {
    Header: 'Last Modified',
    accessor: 'lastModified',
    Cell: ({ value }) => formatter.dateTime(value)
  }
]

const TaxPage = () => {
  const Url = GetUrls();
  return (
  <CardTable
    columns={columns}
    dataKey={Url.getTax.toString()}
    url={Url.getTax}
    modalChild={<TaxAddPage />}
  />
)}

export default TaxPage
